<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4>
          <v-form data-vv-scope="create">
            <v-layout align-center justify-center>
              <v-combobox
                class="width-300 text-xs-left"
                name="carteraOption"
                v-validate="'required'"
                :error-messages="errors.collect('create.orderEmisionType')"
                v-model="carteraOption"
                :items="carteraOptions"
                flat
                item-text="title"
                :allow-overflow="false"
                type="button"
                single-line
                return-object
              >
                <template slot="selection" slot-scope="data">
                  <div>
                    <span style="color:#005cae">{{data.item.title}}</span>
                  </div>
                </template>
              </v-combobox>              
            </v-layout>
           
          </v-form>
        </v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-menu style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            
            <v-list-tile
              class="hidden-xs-only"                         
              @click="generateExcel"
            >
            <v-list-tile-title>Descargar excel</v-list-tile-title>
            </v-list-tile>            
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-card ref="steper">      
      <v-card-text style="padding-top:10px">
       <v-stepper v-model="currentStep" class>
          <v-layout row wrap>
            <v-flex lg12>
              <v-stepper-header>
                <v-stepper-step
                  :complete="currentStep >= 1"
                  :editable="currentStep == 1"
                  step="1"
                  >Estado de Cuenta</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  :complete="currentStep >= 2"
                  :editable="currentStep == 2"
                  step="2"
                  >Resumen de Pago</v-stepper-step
                >
                <v-divider></v-divider>
              
                <v-stepper-step
                  :complete="currentStep >= 3"
                  :editable="currentStep == 3"
                  step="3"
                  >Botón de Pagos</v-stepper-step
                >
               
              </v-stepper-header>
            </v-flex>
          </v-layout>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-layout row wrap>
                <v-flex xs6 md2>
                  <v-autocomplete
                    name="sucursal"
                    label="Sucursal"
                    v-model="filters.sucursal"
                    :items="agencias"
                    flat
                    item-value="valor"
                    item-text="valor"

                    clearable
                  >
                  </v-autocomplete>    
                </v-flex>
                <v-flex xs6 md2>
                  <v-autocomplete
                    name="lineaNegocio"
                    label="Linea de Negocio"
                    v-model="filters.lineaNegocio"
                    :items="lineasNegocio"
                    flat
                    item-value="valor"
                    item-text="valor"

                    clearable
                  >
                  </v-autocomplete>  
                </v-flex>
                 <v-flex xs6 md2>
                  <v-text-field
                    label="Identificación"
                    name="idSoliciatnte"
                    v-model="filters.idSolicitante"
                    style="height: 50px;"
                  >
                  </v-text-field>
                  <span style="margin-top:0px ;">*Este filtro habilita botón de pagos</span>
                </v-flex>
                <v-flex xs6 md2>
                  <v-autocomplete
                    name="provision"
                    label="Provisión"
                    v-model="filters.provision"
                    :items="provisionOptions"
                    flat
                    item-value="value"
                    item-text="title"
                    clearable
                  >
                  </v-autocomplete>  
                </v-flex>
                <v-flex xs6 md2>
                  <v-text-field
                    label="Póliza"
                    name="poliza"
                    v-model="filters.poliza"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 md2>
                  <v-text-field
                    label="Recibo"
                    name="recibo"
                    v-model="filters.recibo"
                  >
                  </v-text-field>
                </v-flex>
                <br/>
               
              </v-layout> 
              <v-layout row wrap justify-end >   
                <v-flex xs3 md2 >
                  <v-btn
                    small
                    style="margin-top: 0px;" 
                    color="default" 
                    @click="querySearch"
                    >FILTRAR</v-btn
                  >
                </v-flex>
                <v-flex xs3 md2>
                  <v-btn
                    small
                    style="margin-top: 0px;" 
                    color="default" 
                    @click="clearQuery"
                    >LIMPIAR</v-btn
                  >
                </v-flex>
              </v-layout>           
              <v-data-table
                flat
                item-key="idCuota"
                :items="carteraPaging"
                :pagination.sync="pagination"
                :rows-per-page-items="pagination.rowsPerPageItems"
                :total-items="pagination.totalItems"
                :headers="headers"                
                v-model="selected"
                class="v-table-list theme--light"
              >
                <template slot="headers" scope="props">
                  <tr class="border-buttom">
                    <!-- style="border:1px #d2d5d8 solid" -->
                    <th>                      
                    </th>
                    <th
                      class="pr-1"
                      v-for="(header,i) in props.headers"
                      :key="i"
                      :class="['column  text-xs-left', header.sortable ? 'sortable'+ pagination.descending ? ' desc' : ' asc' + header.value === pagination.sortBy ? ' active' : '' :'']"
                      @click="changeSort(header)"
                    > 
                      <center>
                        <span>{{header.text}}</span>
                      </center>
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                    </th>
                    <th>      
                      Acciones
                    </th>
                  </tr>
                </template>
                <template slot="items" scope="props">
                  <tr>
                    <td>
                      <v-checkbox 
                        :disabled="!filtrado"
                        :input-value="props.selected"
                        style="position:relative; top:10px"
                        @click="props.selected=!props.selected"
                        small
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.sucursal }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.lineaNegocio }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.idSolicitante }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.nombreSolicitante }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.recibo }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.facturaReal }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.provision }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.nombreRamo }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.poliza }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.certificado }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.endoso }}</td>
                    <td class="text-xs-center cut-text pr-1">{{  props.item.saldo.toFixed(2) }}</td>
                    <th>
                      <v-btn icon title="Ver detalle" @click="viewDetail(props.item)">
                        <v-icon color="primary">fa fa-eye</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </template>
                <template slot="no-data">
                  <div>{{$t('message.noOrderEmissions')}}</div>
                </template>
                <template slot="actions-prepend" class="prepent">
                  
                </template>
                <template
                  slot="pageText"
                  slot-scope="props"
                >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
              </v-data-table>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-layout row wrap>                
                 <v-flex xs12 md4>
                  <v-text-field
                    label="Teléfono celular"                    
                    v-model="resumen.celular"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Correo electrónico"                    
                    v-model="resumen.email"
                  >
                  </v-text-field>
                </v-flex>                
              </v-layout>       
              <v-layout style="margin-top: -30px">
                <v-flex>
                  <small>
                    * Confirme la información Teléfono celular y Correo electrónico para envío de notificación de cobro.
                  </small>                  
                </v-flex>
              </v-layout>   
              <v-data-table
                flat                
                :items="selected"                
                :headers="headers"
                v-model="selected"                
                :pagination.sync="paginationSelected"
                :rows-per-page-items="paginationSelected.rowsPerPageItems"
                :total-items="paginationSelected.totalItems"
                class="v-table-list theme--light"
              >
                <template slot="headers" scope="props">
                  <tr class="border-buttom">                    
                    <th
                    class="pr-1"
                      v-for="(header,i) in props.headers"
                      :key="i"
                      :class="['column  text-xs-left', header.sortable ? 'sortable'+ pagination.descending ? ' desc' : ' asc' + header.value === pagination.sortBy ? ' active' : '' :'']"
                      @click="changeSort(header)"
                    > 
                      <center>
                        <span>{{header.text}}</span>
                      </center>
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                    </th>
                    <th>      
                      Acciones
                    </th>
                  </tr>
                </template>
                <template slot="items" scope="props">
                  <tr>                    
                    <td class="text-xs-left cut-text pr-1">{{ props.item.sucursal }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.lineaNegocio }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.idSolicitante }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.nombreSolicitante }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.recibo }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.facturaReal }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.provision }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.nombreRamo }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.poliza }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.certificado }}</td>
                    <td class="text-xs-left cut-text pr-1">{{ props.item.endoso }}</td>
                    <td class="text-xs-center cut-text pr-1">{{ props.item.saldo.toFixed(2)   }}</td>
                    <th>
                      <v-btn icon title="Ver detalle" @click="viewDetail(props.item)">
                        <v-icon color="primary">fa fa-eye</v-icon>
                      </v-btn>
                    </th>
                  </tr>
                </template>                
              </v-data-table>
              <v-layout row wrap>                
                 <v-flex>
                  
                </v-flex>               
              </v-layout>          
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-layout row wrap>
          <v-flex xs6>              
            </v-flex>
          <v-flex xs6 text-lg-right>
            <v-layout row wrap>
              <v-flex xs9 text-lg-right>              
                  <span style="color:#00AEEF; font-size: 14px; font-weight: bold">Total Seleccionado:</span>
                </v-flex>
              <v-flex xs3 text-lg-right>                  
                  <div class="pr-3"
                    style="color:#00AEEF; font-size: 16px; font-weight: bold; background-color: #EAEBED; text-align: right"
                  >
                    ${{total}}
                  </div>
              </v-flex>
            </v-layout>    
          </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs7>
              <div
                v-if="currentStep == 1"
              >
                <b>Consideraciones:</b><br>
                Debe filtrar por identificación, para habilitar la selección de registros y realizar el cobro por botón de pagos.<br>   
              </div>       
              <div
                v-if="currentStep == 2"
              >
                <b>Consideraciones:</b><br>
                Una vez realizado el pago por el cliente con su tarjeta de crédito, el pago será aplicado en un máximo de 72 horas laborables.<br>
                Para mayor información, por  favor comunícate con tu ejecutivo de cartera.       
              </div>
            </v-flex>
            <v-flex xs5>
              <v-flex xs12 text-lg-right>
                <v-btn @click="cancel"
                  :disabled="desabilitaBotones"
                >{{ $t("message.cancel") }}</v-btn>
                <v-btn
                  :disabled="desabilitaBotones"
                  @click="beforeStep()"
                  v-if="currentStep > 1"
                  color="accent"
                  >{{ $t("message.before") }}</v-btn
                >
                <v-btn @click="nextStep()" color="accent"
                  :disabled="selected.length == 0 || desabilitaBotones"
                >
                  {{currentStep == 2 ? "Realizar Pago" : $t("message.next")}}
                </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog"  max-width="1000px">      
      <v-card>                
        <v-card-title style="color: #00aeef; padding-bottom:5px">
          <h3>Detalle del Registro</h3>
        </v-card-title>
        <v-card-text style="vertical-align: top; padding-top:-5px">
          <v-container>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Sucursal"
                    :value="item.sucursal"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Sistema"
                    :value="item.sistemaFuente"                    
                ></v-text-field>
              </v-flex>       
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Línea de negocio"
                    :value="item.lineaNegocio"                    
                ></v-text-field>
              </v-flex>       
            </v-layout>      

            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Id solicitante"
                    :value="item.idSolicitante"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Nombre solicitante"
                    :value="item.nombreSolicitante"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Email personal"
                    :value="item.emailPersonal"                    
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Celular"
                    :value="item.telefonoCelular"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Id asegurado"
                    :value="item.idAsegurado"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Nombre asegurado"
                    :value="item.nombreAsegurado"                    
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Id beneficiario"
                    :value="item.idBeneficiario"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Nombre beneficiario"
                    :value="item.nombreBeneficiario"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Recibo"
                    :value="item.recibo"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="No documento"
                    :value="item.numeroDocumento"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Factura real"
                    :value="item.facturaReal"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Tipo documento"
                    :value="item.tipoDocumento"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Orden documento"
                    :value="item.ordenDocumento"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Fecha emisión"
                    :value="item.fechaEmision"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Inicio vigencia"
                    :value="item.inicioVigencia"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Fin vigencia"
                    :value="item.finVigencia"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Nombre ramo"
                    :value="item.nombreRamo"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Póliza"
                    :value="item.poliza"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Certificado"
                    :value="item.certificado"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Endoso"
                    :value="item.endoso"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Fecha de vencimiento"
                    :value="item.fechaVencimiento"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Días vencidos"
                    :value="item.diasVencidos"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Provisión"
                    :value="item.provision"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Valor"
                    :value="item.valor"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Saldo"
                    :value="(Math.round(item.saldo * 100) / 100).toFixed(2)"                    
                ></v-text-field>
              </v-flex>     
              <v-flex xs12 md4 class="mr-3">
                <v-text-field
                    readonly
                    label="Endoso Beneficiario"
                    :value="item.endosoBeneficiario"                    
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                    readonly
                    label="Beneficiario Endoso"
                    :value="item.beneficiarioEndoso"                    
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider style="margin:0px"></v-divider>     
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small text @click="dialog = false">Cerrar</v-btn>                    
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";
import ConfirmDialog from "@/components/Widgets/ConfirmDialog";
import { EventBus } from '@/imports/EventBus';
import { downloadEXCEL } from "@/common/helpers/helpers";
import BotonPagoServices  from "@/services/BotonPagoServices";

export default {
  components: {
    
    ConfirmDialog
  },
  computed: {

    ...mapGetters([
      "loadingCartera",       
      "provisionOptions",
      "carteraFileExcel",
      "userProfile"
      ]),

    pagination: {
      get: function() {
        return this.$store.getters.paginationCartera;
      },
      set: function(value) {
        this.$store.commit("setPaginationCartera", value);
      }
    },
    
    carteraPaging() {
      return this.$store.getters.carteraPaging;
    },

    total(){
      return this.selected.length == 0 
        ? 0 
        : this.selected.reduce((n, {saldo}) => n + saldo, 0).toFixed(2);
    },
    redondearSaldo(numero){
      
      return (Math.round(numero * 100) / 100).toFixed(2);
    }
  },
  mounted() {
    this.$store.dispatch("getAgencias")
      .then(res=> {
        this.agencias = res;
    });
    this.$store.dispatch("getLineasNegocio")
      .then(res=> {
        this.lineasNegocio = res;
        //this.lineasNegocio.unshift({ clave: "", valor: "" })
    });
  
    this.carteraOption = this.carteraOptions[0];
    this.querySearch()
  },
  watch: {    
    
    pagination: {
      handler() {
        this.$store
          .dispatch("getCartera", this.filters)
          .then(result => {});
      },
      deep: true
    },

    loadingCartera(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando información, por favor espere...");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
  
    selected(val){
      if(val.length > 40){
        this.$root.$emit("showSnackBar", "No puede seleccionar más de 40 registros");
        val.pop();
      }
    }
  },
  methods: {
    viewDetail(item){
      this.dialog = true;
      this.item = item;
    },

    clearQuery(){
      this.filters = {
        sucursal: "",
        lineaNegocio: "",
        idSolicitante: "",
        provision: undefined,
        poliza : "",
        recibo : ""
      };
      this.selected = [];
      this.filtrado = false;
      this.querySearch();
    },
    nzDate: nzDate,
   
    querySearch() {
      
      this.$store
        .dispatch("getCartera", this.filters)
        .then(result => {
          if(this.filters.idSolicitante != "" || this.filters.poliza != "" || this.filters.recibo != "")
          {
            this.filtrado = true;
          }
        });
    },

     generateExcel() {      
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch("getCarteraExcel", this.filters)
        .then((res) => {
          if (this.carteraFileExcel.byteLength < 100) {
            this.$root.$emit("showSnackBar", "No existen datos", "warning");
            return;
          }
          let fecha = new Date();           
          let fechaTexto = ((fecha.getDate()) > 9 ? '' : '0') + (fecha.getDate()) + ((fecha.getMonth() + 1) > 9 ? '' : '0') + (fecha.getMonth() + 1) + fecha.getFullYear() +  "" + fecha.getHours() +  "" + fecha.getMinutes()
          downloadEXCEL(
            this.carteraFileExcel,
            "CarteraAps"+fechaTexto+".xlsx"
          );
          
        });
    },

    cancel(){
      this.selected = [];
      this.filtrado = false;
      this.currentStep = 1;
    },

    beforeStep() {      
      this.currentStep--;
    },

    nextStep(){
      this.currentStep++;
      if(this.currentStep == 2){
        this.resumen.celular = this.selected[0].telefonoCelular;
        this.resumen.email = this.selected[0].emailPersonal;
        if(this.resumen.email){
          this.resumen.email = this.resumen.email.toLowerCase();
        }
      }
      else if (this.currentStep == 3){
        this.getPayment();
      }
    },

    getPayment(){
      this.desabilitaBotones = true;
      let reg = this.selected[0];

      let paymentModel = {
        clientCode: reg.idSolicitante,
        clientName: reg.nombreSolicitante,
        clientEmail: this.resumen.email,
        phoneNumber: this.resumen.celular,
        detail1: "",
        detail2: "",
        detail3: "",
        detail4: "",
        detail5: this.userProfile.user_name,
        userId: this.userProfile.user_id,
        subtotal: 0,
        subtotalIvaCero: this.total,
        iva: 0,
        ice: 0,
        clientTransactionId: ""
      };

      let counter = 0;
      this.selected.forEach(item => {
        counter++;
        if(counter <= 10){
          paymentModel.detail1 += item.recibo + ",";
        } 
        else if(counter <= 20){
          paymentModel.detail2 += item.recibo + ",";        
        }
        else if(counter <= 30){
          paymentModel.detail3 += item.recibo + ",";        
        }
        else if(counter <= 40){
          paymentModel.detail4 += item.recibo + ",";        
        }        
      });

      if(paymentModel.detail1.length > 0)
        paymentModel.detail1 = paymentModel.detail1.substring(0,paymentModel.detail1.length -1)
      if(paymentModel.detail2.length > 0)
        paymentModel.detail2 = paymentModel.detail2.substring(0,paymentModel.detail2.length -1)
      if(paymentModel.detail3.length > 0)
        paymentModel.detail3 = paymentModel.detail3.substring(0,paymentModel.detail3.length -1)
      if(paymentModel.detail4.length > 0)
        paymentModel.detail4 = paymentModel.detail4.substring(0,paymentModel.detail4.length -1)

      BotonPagoServices.payment(paymentModel)
        .then(res=> {
          if(res && res.status == 200){
            var data = res.data.Data;
            document.location = data.PaymentUrl;
          }else{
            this.currentStep = 1;
            this.desabilitaBotones = false;
            this.$root.$emit("showSnackBar", "No pudo realizar generar la orden de pago.");
          }
        });
    }
  },
  data() {
    return {     
      search: "",
     
      filters: {
        apsId: "",
        sucursal: "",
        lineaNegocio: "",
        idSolicitante: "",
        provision: "",
        poliza:"",
        recibo:""
      },
      selected:[],
      carteraOptions: [
        {
          id: 1,
          title: "Estado de Cuenta Total",
          url: "/cartera/estadoCuentaTotal"
        },
        
      ],
      carteraOption: undefined,
      searchValue: "",
      currentStep: 1,
      agencias: [],
      lineasNegocio: [],
      dialog: false,
      filtrado: false,
      item: {},
      resumen: {
        celular: "",
        email: ""
      },
      headers: [
        {
          align: "left",
          sortable: false,
          text: "Sucursal",
          value: "sucursal",
        },
        {
          align: "left",
          sortable: false,
          text: "Linea de Negocio",
          value: "lineaNegocio",
        },
        {
          align: "left",
          sortable: false,
          text: "Id Solicitante",
          value: "idSolicitante",
        },
        {
          align: "left",
          sortable: false,
          text: "Nombre Solicitante",
          value: "nombreSolicitante",
        },
        {
          align: "left",
          sortable: false,
          text: "Recibo",
          value: "recibo",
        },
        {
          align: "left",
          sortable: false,
          text: "Factura real",
          value: "facturaReal",
        },
        {
          align: "left",
          sortable: false,
          text: "Provisión",
          value: "provision",
        },
        {
          align: "left",
          sortable: false,
          text: "Nombre Ramo",
          value: "nombreRamo",
        },
        {
          align: "left",
          sortable: false,
          text: "Póliza",
          value: "poliza",
        },
        {
          align: "left",
          sortable: false,
          text: "Certificado",
          value: "certificado",
        },
        {
          align: "left",
          sortable: false,
          text: "Endoso",
          value: "endoso",
        },
        {
          align: "left",
          sortable: false,
          text: "Saldo",
          value: "saldo",
        },
      ],     
      paginationSelected: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: 'sucursal',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
      },
      desabilitaBotones: false
    };
  }
};
</script>
<style >
.theme--light.v-label {
  color: #0a62b1;
  font-size: 12px;
}
.theme-- .v-input--selection-controls__ripple {
  padding: 0px;
  margin: 0px;
}
.v-input--selection-controls__input {
  margin-right: 0px;
}
/* .v-icon{
  font-size: 19px
} */
</style>